const getSharedTripColumns = showOnRoles => [
  {
    title: 'Αριθ. Συμβολαίου',
    dataIndex: 'policyNumber',
    key: 'policyNumber',
    showOnRoles
  },
  {
    title: 'Αριθ. Πινακίδας',
    key: 'plateNumber',
    dataIndex: 'plateNumber',
    showOnRoles
  },
  {
    title: 'IMEI Συσκευής',
    key: 'imei',
    dataIndex: 'imei',
    showOnRoles
  },
  {
    title: 'Αρχή Διαδρομής',
    key: 'startDate',
    dataIndex: 'startDate',
    showOnRoles
  },
  {
    title: 'Τέλος Διαδρομής',
    key: 'endDate',
    dataIndex: 'endDate',
    showOnRoles
  },
  {
    title: 'Km',
    key: 'kilometers',
    dataIndex: 'kilometers',
    showOnRoles
  }
];

export default getSharedTripColumns;
